<template>
  <div>
    <div class="row" v-for="item in fieldsArray">
        <div class="col-sm-1"></div>
      <div class="col-sm-5">
        <div class="fv-plugins-icon-container">
          <label class="d-flex align-items-center fs-5 fw-bold"
            ><span class="required">Field Name</span></label
          ><input
            type="text"
            class="form-control form-control-lg form-control-solid"
            v-model="item.key"
          />
          <div class="fv-plugins-message-container invalid-feedback"></div>
        </div>
      </div>
      <div class="col-sm-5">
        <div class="fv-plugins-icon-container">
          <label class="d-flex align-items-center fs-5 fw-bold"
            ><span class="required">Value</span></label
          ><input
            type="text"
            class="form-control form-control-lg form-control-solid"
            v-model="item.value"
          />
          <div class="fv-plugins-message-container invalid-feedback"></div>
        </div>
      </div>
      <div class="col-sm-1">
        <a @click="deleteField(item.key)">
          <svg
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z"
              stroke="#060606"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
            <path
              d="M14 8L8 14"
              stroke="#060606"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
            <path
              d="M8 8L14 14"
              stroke="#060606"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path></svg
        ></a>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-10"></div>
      <div class="col-sm-2">
        <button class="btn btn-primary" type="button" @click="addField()">
          Add Field
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdditionalFields",
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {

    };
  },
  computed: {
    fieldsArray() {
      return this.value;
    }
  },
  watch: {
    fieldsArray: {
      handler(newVal) {
        this.$emit("input", newVal);
      },
      deep: true,
    },
  },
  methods: {
    addField() {
      const newFieldKey = `New Field ${this.fieldsArray.length}`;
      this.fieldsArray.push({
        key: newFieldKey,
        value: "",
      });
    },
    deleteField(key) {
      const index = this.fieldsArray.findIndex((item) => item.key === key);
      if(index === -1){
        return;
      }
      this.fieldsArray.splice(index, 1);
    },
  }
};
</script>

<style lang="scss" scoped>
</style>